import { render, staticRenderFns } from "./SellerSalesTable.vue?vue&type=template&id=3dfead58&"
import script from "./SellerSalesTable.vue?vue&type=script&lang=js&"
export * from "./SellerSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports